'use client';

import Image from 'next/image';
import Link from 'next/link';
import { memo, useState } from 'react';

import type { ServiceCardProps } from '@routeroyal/theme-core';

export const AllysServiceCard = memo(function AllysServiceCard({ service }: ServiceCardProps) {
  const [imageError, setImageError] = useState(false);

  const cardContent = (
    <>
      {/* Service Icon/Image */}
      {service.icon && (
        <div className="relative h-48 bg-gradient-to-br from-gray-50 to-gray-100">
          {!imageError ? (
          <Image
            src={service.icon}
            alt={service.title}
            fill
            className="object-cover group-hover:scale-105 transition-transform duration-300"
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
              onError={() => setImageError(true)}
            />
          ) : (
            <div className="flex items-center justify-center h-full bg-gray-200">
              <svg className="w-12 h-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
            </div>
          )}
        </div>
      )}
      
      {/* Content */}
      <div className="p-6">
        <h3 className="text-xl font-semibold text-gray-900 mb-3 group-hover:text-primary transition-colors">
          {service.title}
        </h3>
        <p className="text-gray-600 text-sm leading-relaxed mb-4">
          {service.description}
        </p>
        
        {service.link && (
          <span className="inline-flex items-center text-sm font-medium text-primary group-hover:text-primary/80 transition-colors">
            Learn more
            <svg className="ml-2 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </span>
        )}
      </div>
    </>
  );

  // Wrap in link if service has a link
  if (service.link) {
    return (
      <Link href={service.link} className="group block">
        <div className="relative bg-white border border-gray-200 rounded-2xl overflow-hidden hover:shadow-xl transition-all duration-300">
          {cardContent}
        </div>
      </Link>
    );
  }

  return (
    <div className="group relative bg-white border border-gray-200 rounded-2xl overflow-hidden hover:shadow-xl transition-all duration-300">
      {cardContent}
    </div>
  );
});

